// extracted by mini-css-extract-plugin
module.exports = {"logs_list":"logs_list--BookingLogGroup-BookingLogList-components__13qPA","logsList":"logs_list--BookingLogGroup-BookingLogList-components__13qPA"};